<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-primary pt-3 pb-6">
      <div class="container">
        <notifications></notifications>
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-bottom: 5px; width: 100%">
              <h1 class="text-white">Bienvenido al Portal PRL de Misepis</h1>
            </div>

            <!--   <div class="text-white">
              <h3 class="text-white">
                <strong>Acceso equipos Gmat:</strong>
              </h3>
              <div>
                Usuario: <b>info@delfrom.com</b> Contraseña:
                <b>password</b>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <!-- <div class="card-header bg-transparent pb-5">
              <div class="text-muted text-center mt-2 mb-3">
                <small>Sign in with</small>
              </div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="/img/icons/common/github.svg"
                  /></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="/img/icons/common/google.svg"
                  /></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </div> -->
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h3>Iniciar sesión</h3>
              </div>
              <form role="form" @submit.prevent="handleSubmit()">
                <base-input
                  alternative
                  class="mb-3"
                  name="Email"
                  prepend-icon="ni ni-email-83"
                  placeholder="Usuario"
                  v-model="email"
                />
                <validation-error :errors="apiValidationErrors.email" />

                <base-password-input
                  alternative
                  class="mb-3"
                  name="Password"
                  prepend-icon="ni ni-lock-circle-open"
                  placeholder="Contraseña"
                  v-model="password"
                >
                </base-password-input>
                <validation-error :errors="apiValidationErrors.password" />

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Acceder</base-button
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <a href="/password/reset" class="text-light"
                ><small>¿Olvidó su contraseña?</small></a
              >
            </div>
            <!--  <div class="col-6 text-right">
              <a href="/register" class="text-light"
                ><small>Crear nueva cuenta</small></a
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
export default {
  components: {
    ValidationError,
  },
  mixins: [formMixin],
  data: () => ({
    /*  email: "cbodi@salvadorvertical.com",
    password: "password", */
    email: "",
    password: "",
  }),
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  },
  methods: {
    async handleSubmit() {
      const user = {
        identifier: this.email,
        password: this.password,
      };

      const requestOptions = {
        /*  headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        }, */
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Las credenciales no son correctas",
        });
        this.setApiValidation(error);
      }
    },
  },
};
</script>
